import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/AlertDialog";
import { Button } from "../ui/Button";
import { useDeleteRelease } from "../../hooks/useAdminApi";
import type { Release } from "../../types";

interface ReleaseDeleteDialogProps {
  release: Release | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const ReleaseDeleteDialog: React.FC<ReleaseDeleteDialogProps> = ({
  release,
  open,
  onOpenChange,
}) => {
  const remove = useDeleteRelease();

  const handleConfirm = async () => {
    if (!release) return;
    await remove.mutateAsync(release.id);
    onOpenChange(false);
  };

  if (!release) return null;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remover release?</AlertDialogTitle>
          <AlertDialogDescription>
            A release{" "}
            <span className="font-mono text-foreground font-semibold">
              {release.tagName}
            </span>{" "}
            será removida do banco. Você pode regenerá-la depois a partir da tag do Git, mas
            edições manuais serão perdidas.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel asChild>
            <Button variant="secondary" type="button">
              Cancelar
            </Button>
          </AlertDialogCancel>
          <AlertDialogAction asChild>
            <Button
              variant="danger"
              type="button"
              onClick={handleConfirm}
              disabled={remove.isLoading}
            >
              {remove.isLoading ? "Removendo…" : "Remover"}
            </Button>
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
